import React from "react";
import module_style from "../style.module.css";
import { MoreActions } from "ui/modules/MoreActions";
import EditIcon from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Dots from "@material-ui/icons/DragIndicator";
import { isInteger } from "utils/validations";

const MediaList = ({
  data,
  set_show_modal,
  set_selected_id,
  set_data,
  handleDelete,
  disableAllEdits,
}) => {
  const options = [
    {
      title: "Edit",
      icon: <EditIcon />,
      handleClick: () => set_show_modal(true),
    },
    { title: "Delete", icon: <Delete />, handleClick: () => handleDelete() },
  ];

  const handleOnDragEnd = (result) => {
    if (
      !isInteger(result?.destination?.index) ||
      !isInteger(result?.source?.index)
    )
      return;
    let temp = data;
    const reorderedData = temp.splice(result.source.index, 1);
    temp.splice(result.destination.index, 0, ...reorderedData);
    for (let i = 0; i < temp.length; i++) {
      let item = temp[i];
      item.id = i;
    }

    set_data([...temp]);
  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="media" type="MEDIA" mode="standard">
        {(provided) => (
          <div ref={provided.innerRef}>
            {data
              ?.filter((item) => !item.draft)
              .map((item, index) => (
                <Draggable
                  key={`media-${item?.id}`}
                  draggableId={`media-${item?.id}`}
                  index={index}
                >
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.draggableProps}>
                      <div className={`mt-2 mb-2 position-relative`}>
                        {provided && (
                          <div
                            className={`mr-1 ${module_style.drag_svg} ${module_style.media_dots}`}
                            style={{ cursor: "grab" }}
                            {...provided.dragHandleProps}
                          >
                            <Dots />
                          </div>
                        )}
                        <div className={`${module_style.card}`}>
                          <div
                            className={`${module_style.dots_svg} ${module_style.media_dots}`}
                          >
                            {disableAllEdits ? null : (
                              <div onClick={() => set_selected_id(item.id)}>
                                <MoreActions
                                  options={options}
                                  shift={{ x: 45, y: 70 }}
                                />
                              </div>
                            )}
                          </div>
                          <div
                            className={`${module_style.media_title} line_max_1`}
                          >
                            {item?.media_title}
                          </div>
                          <div className={`${module_style.media_line}`}></div>

                          <div className={`d-flex`}>
                            <img
                              src={item?.media_logo}
                              alt="media_logo"
                              className={`${module_style.media_logo}`}
                            />

                            <div
                              className={`ml-2 d-flex flex-column justify-content-between`}
                            >
                              <div
                                className={`${module_style.media_description} line_max_1`}
                              >
                                {item?.organisation_name}
                              </div>
                              <div className={`${module_style.media_info}`}>
                                Posted on: {item?.date}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default MediaList;
